import { render, staticRenderFns } from "./ConfirmHeader.vue?vue&type=template&id=1d6bfd4f&scoped=true"
import script from "./ConfirmHeader.vue?vue&type=script&lang=js"
export * from "./ConfirmHeader.vue?vue&type=script&lang=js"
import style0 from "./ConfirmHeader.vue?vue&type=style&index=0&id=1d6bfd4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6bfd4f",
  null
  
)

export default component.exports